module.exports = "/_next/static/public/images/register-hero-6c36b9bdfe1d6ea87fea3159acf04d1d.jpg";